module.exports = __webpack_public_path__ + "static/flags/FG-caba8cce32ec87120bd92b1df1ed3284.gif";